import {
  get,
  post,
  put,
  patch,
  del,
  createQueryParams,
  getLocalStorageData,
} from "../../axiosComponent";
import { serviceUrls } from "../../constant";

const prepareTransportData = (data = {}) => {
  const profileDetails = getLocalStorageData("profileDetails");
  return {
    ...data,
    siteId: profileDetails["_SITE"],
    regionId: profileDetails["_REGION"],
    organizationId: profileDetails["_ORGANIZATION_"]["_ID"],
  };
};

export const getMaintenanceList = async (data) => {
  return await get({
    url: serviceUrls.TRANSPORT_SERVICE + "/maintenance/list",
    params: createQueryParams(prepareTransportData(data)),
    includeOrgHeaders: true,
  });
};

export const getMaintenance = async (entityId) => {
  return await get({
    url: serviceUrls.TRANSPORT_SERVICE + "/maintenance",
    params: createQueryParams({ entityId }),
    includeOrgHeaders: true,
  });
};

export const addMaintenance = async (data) => {
  return await post({
    url: serviceUrls.TRANSPORT_SERVICE + "/maintenance",
    data: prepareTransportData(data),
    includeOrgHeaders: true,
  });
};

export const updateMaintenance = async (data) => {
  return await put({
    url: serviceUrls.TRANSPORT_SERVICE + "/maintenance",
    data: prepareTransportData(data),
    includeOrgHeaders: true,
  });
};

export const deleteMaintenance = async (entityId) => {
  return await del({
    url: serviceUrls.TRANSPORT_SERVICE + "/maintenance",
    params: createQueryParams({ entityId }),
    includeOrgHeaders: true,
  });
};

export const updateMaintenanceStatus = async (data) => {
  return await patch({
    url: serviceUrls.TRANSPORT_SERVICE + "/maintenance",
    params: createQueryParams(prepareTransportData(data)),
    includeOrgHeaders: true,
  });
};

export const getVehicleMaintenanceHistory = async (data) => {
  return await get({
    url: serviceUrls.TRANSPORT_SERVICE + "/maintenance/vehicle/history",
    params: createQueryParams(prepareTransportData(data)),
    includeOrgHeaders: true,
  });
};

export const schedulePreventiveMaintenance = async (data) => {
  return await post({
    url: serviceUrls.TRANSPORT_SERVICE + "/maintenance/schedule",
    data: prepareTransportData(data),
    includeOrgHeaders: true,
  });
};

export const completeMaintenanceTask = async (data) => {
  return await patch({
    url: serviceUrls.TRANSPORT_SERVICE + "/maintenance/complete",
    data: prepareTransportData(data),
    includeOrgHeaders: true,
  });
};

export const getMaintenanceCostSummary = async (data) => {
  return await get({
    url: serviceUrls.TRANSPORT_SERVICE + "/maintenance/costs",
    params: createQueryParams(prepareTransportData(data)),
    includeOrgHeaders: true,
  });
};
